import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { BaseHttpService } from 'src/app/service/base-http.service';

@Component({
	selector: 'app-sys-branch-list',
	templateUrl: './sys-branch-list.component.html',
	styleUrls: ['./sys-branch-list.component.css']
})
export class SysBranchListComponent implements OnInit {
	error=null
	loading = false
	hasEditPerm = false;
	sysBranchList = null
	sysBranchPagination = {
		currentPage: 1,
		pageSize: 10,
		pageCount: 0,
		rowCount: 0,
		pageList: null
	}
	searchForm: FormGroup = this.formBuilder.group({
		codeLike: ['', [Validators.maxLength(200)]],
		nameLike: ['', [Validators.maxLength(200)]],
		status: [null]
	});
	branchStatusOptionList = [
		{ value: null, label: "Tất cả" },
		{ value: 0, label: "Ngừng sử dụng" },
		{ value: 1, label: "Sử dụng" }
	]
	branchStatusOptionMap = {}
	constructor(private authService: AuthService,
		private formBuilder: FormBuilder,
		private httpService: BaseHttpService,
		private route: ActivatedRoute,
		private router: Router) { }
	ngOnInit(): void {
		this.authService.hasAnyPerm(['SYS_APPLICATION']).subscribe(hasPerm => {
			this.hasEditPerm = hasPerm;
		})
		for (var branchStatusOption of this.branchStatusOptionList) {
			this.branchStatusOptionMap[branchStatusOption.value] = branchStatusOption.label;
		}
		this.searchBranch();
	}

	sysBranchPageChange(page) {
		if(this.loading){
			return;
		}
		this.error = null;
		var searchFormData = this.searchForm.getRawValue()
		var findRequest: any = {}
		var codeLike = searchFormData["codeLike"];
		if (codeLike) {
			findRequest.codeLike = `%${codeLike}%`;
		}
		var nameLike = searchFormData["nameLike"];
		if (nameLike) {
			findRequest.nameLike = `%${nameLike}%`;
		}
		var status = searchFormData["status"];
		if (status !== null) {
			findRequest.status = status;
		}
		if (page < 1) {
			page = 1
		}
		findRequest.queryOffset = (page - 1) * this.sysBranchPagination.pageSize;
		findRequest.queryLimit = this.sysBranchPagination.pageSize;
		this.loading=true;
		this.httpService.post<any>(`/api/admin/sys/branch/search`, findRequest).subscribe(findOtpBranchResponse => {
			this.loading=false;
			var rowCount = findOtpBranchResponse.rowCount;
			var pageCount = Math.ceil(rowCount / this.sysBranchPagination.pageSize);
			var pageList = []
			for (var i = page - 2; i <= page + 2; i++) {
				if (i >= 1 && i <= pageCount) {
					pageList.push(i);
				}
			}
			this.sysBranchPagination.currentPage = page;
			this.sysBranchPagination.rowCount = rowCount;
			this.sysBranchPagination.pageCount = pageCount;
			this.sysBranchPagination.pageList = pageList;
			this.sysBranchList = findOtpBranchResponse.resultList;
		}, errorResponse => {
			this.loading=false;
			if(errorResponse.status==403){
			  this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
			  return;
			}
			if (errorResponse.status > 0) {
				if (errorResponse.error?.errorCode) {
					this.error = errorResponse.error.errorCode + (errorResponse.error.errorMessage ? ":" + errorResponse.error.errorMessage : "");
					return;
				}
				this.error = errorResponse.status + ":" + errorResponse.error.error + (errorResponse.error.message ? ":" + errorResponse.error.message : "");
				return;
			}
			this.error = "Lỗi kết nối! Vui lòng thử lại sau";
		});
	}
	searchBranch() {
		this.sysBranchPageChange(1);
	}
	viewBranch(sysBranch) {
		this.router.navigate(['view', sysBranch.id], { relativeTo: this.route })
	}
	insertBranch() {
		this.router.navigate(['create'], { relativeTo: this.route })
	}
	editBranch(sysBranch) {
		this.router.navigate(['edit', sysBranch.id], { relativeTo: this.route })
	}
	deleteBranch(sysBranch) {
		this.router.navigate(['delete', sysBranch.id], { relativeTo: this.route })
	}
}


